import './style.scss';
import {
  PAGINATION_PREV_DISABLED_CLASSNAME,
  PAGINATION_NEXT_DISABLED_CLASSNAME,
  ACTIVE_PAGINATION_NUMBER_CLASSNAME,
} from './constants';
import {
  isDefined,
  getURL,
  initiateTableLoading,
  updateNavButtonsState,
  updateNumberButtonsState,
  isPaginationEnabled,
  fetchPaginatedTable,
  reselectCompareCheckboxes,
} from './helpers/pagination';
import {
  getPrevButtonDOM,
  getNextButtonDOM,
  getAllNumberButtonsDOM,
  getNumberButtonDOM,
  getActiveNumberButtonDOM,
  scrollToTop,
} from './helpers/dom';
import lazyLoadImagesOnTable from '../table/lazy-load-images';

const PAGINATION_CLASSNAME = 'comparison-table__paginationNav';

const updatePaginationButtons = (paginationContainer, offsetValues) => {
  const navButtons = {
    prevButton: getPrevButtonDOM(paginationContainer),
    nextButton: getNextButtonDOM(paginationContainer),
  };
  updateNavButtonsState(navButtons, offsetValues, {
    prevButton: PAGINATION_PREV_DISABLED_CLASSNAME,
    nextButton: PAGINATION_NEXT_DISABLED_CLASSNAME,
  });
  updateNumberButtonsState(ACTIVE_PAGINATION_NUMBER_CLASSNAME, {
    prevActiveButton: getActiveNumberButtonDOM(paginationContainer),
    activeButton: getNumberButtonDOM(paginationContainer, offsetValues.offset),
  });
};

const initPagination = (table, parentContainer) => {
  const comparisonTable = table;
  const paginationContainer = parentContainer.querySelector(`.${PAGINATION_CLASSNAME}`);
  const {
    paginationNav: tableRowCount,
    paginationNavOffset,
  } = comparisonTable.dataset;

  if (
    !table ||
    !parentContainer ||
    !isPaginationEnabled(paginationContainer, tableRowCount, paginationNavOffset)
  ) {
    throw new Error('Table pagination is not set-up correctly.');
  }

  const updatePaginatedTable = ({ html, nextOffset, prevOffset, offset = 0 }) => {
    if (!isDefined(html) || !isDefined(nextOffset) || !isDefined(prevOffset)) {
      throw new Error('Table cannot be updated, check api response.');
    }

    comparisonTable.querySelector('tbody').innerHTML = html;
    comparisonTable.dataset.paginationNavOffset = offset;
    updatePaginationButtons(paginationContainer, {
      nextOffset,
      prevOffset,
      offset,
    });
    initiateTableLoading(table, false);
    lazyLoadImagesOnTable(table);
    reselectCompareCheckboxes(table.parentNode);
  };

  const handlePagination = (event) => {
    event.preventDefault();
    const { offset } = event.target.dataset;
    const { paginationNavOffset: currentOffset, ajaxTableSorting } = table.dataset;
    const shouldFetchRows = offset !== 'null' && Number(offset) !== Number(currentOffset || 0);
    const url = getURL(parentContainer.dataset, offset, tableRowCount, ajaxTableSorting);

    if (shouldFetchRows === true && url) {
      initiateTableLoading(table);
      fetchPaginatedTable(url)
        .then((response) => {
          updatePaginatedTable({ ...response, offset });
          scrollToTop(parentContainer);
        });
    }
  };

  getPrevButtonDOM(paginationContainer)
    .addEventListener('click', handlePagination);

  getNextButtonDOM(paginationContainer)
    .addEventListener('click', handlePagination);

  [...getAllNumberButtonsDOM(paginationContainer)]
    .forEach(numberNav => numberNav.addEventListener('click', handlePagination));

  table.addEventListener('update-paginated-table', ({ detail }) => updatePaginatedTable(detail));
};

export default initPagination;
